<template>
  <div id="container">
    <div
      class="item-box-content"
      style="padding:14px 20px">
      <div class="title-font-style">
        <span>角色权限管理</span>
      </div>
    </div>
    <div class="content_role">
      <div class="left">
        <div class="pb20">
          <div class="roleName">
            <img
              src="@/assets/img/more.png"
              class="left-logo"
              alt
              srcset />
            <div class="right_add">角色名称</div>
            <div
              class="right_select_add"
              style="color:#276CFF;font-size:14px;cursor:pointer;"
              @click="toaddRoleInfo"
            >+&nbsp;添加角色
            </div>
          </div>
        </div>
        <div class="rolellist">
          <ul>
            <li
              v-for="(v,i) in roelNameList"
              :key="i"
              v-cust
              :class="currindex===i?'activerole':'roleNamw'"
              @click="toclick(i,v)"
            >
              <div class="leftcontent">
                <span style="width:10%;margin-left:12px">{{i+1}}</span>
                <el-tooltip
                  :disabled="v.roleName.length < 8"
                  class="item"
                  effect="dark"
                  :content="v.roleName"
                  placement="top-start">
                  <span
                    style="width:80%;text-aligin:left;margin-left:20px"
                  >{{v.roleName.length>8?v.roleName.substring(0,8)+'......':v.roleName}}</span>
                </el-tooltip>
              </div>

              <span
                class="icong_span"
                style="padding:8px 10px;line-height: 30px;height: 40px;overflow: hidden">
                <el-popover
                  placement="bottom"
                  class="content"
                  popper-class="poperhover"
                  trigger="hover">
                    <div slot="reference">
                      <img
                        src="@/assets/img/more.png"
                        alt
                        srcset />
                    </div>
                    <div>
                      <div
                        @click="toaddRoleInfo(v)"
                        class="delete_info"
                        style="color:#4E555B;width:150px;height:31px;cursor:pointer;text-align:center;line-height:30px"
                      >修改角色</div>
                      <div
                        @click="toshow(v)"
                        class="delete_info"
                        style="color:#D35E5E;width:150px;height:31px;cursor:pointer;text-align:center;line-height:30px"
                      >删除角色</div>
                    </div>
                </el-popover>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="right"
        v-loading="loding"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <div class="right_top">
          <div style>角色名称：{{currendItem.roleName}}</div>
          <div>
            <el-button
              type="primary"
              @click="tosave">保存
            </el-button>
          </div>
        </div>
        <div class="content_bottom">
          <div class="left">
            <div class="top">查看权限</div>
            <div class="left_tree">
              <el-tree
                :data="listAll"
                node-key="id"
                ref="tree"
                show-checkbox
                :props="defaultProps"
                :default-checked-keys="selectLit"
                :check-strictly="false"
                @check="seeNodeClick"
              >
                <span
                  slot-scope="{ node,data }"
                  style="flex: 1;"
                  class="slot_title"
                  @click.self="loadChildData($event,node,data)">
                  <span @click.self="loadChildDataex($event,node,data)">{{node.label}}</span>
                  <!--                  <i v-if="data.postPower" class="iconfont icon-youjiantou-01" style="font-size: 12px;vertical-align: middle;margin-left: 5px;font-style: normal"></i>-->
                </span>
              </el-tree>
            </div>
          </div>

          <div
            class="right"
          >
            <div class="top">操作权限</div>
            <div class="itemsource_box">
              <div
                v-for="(item,index) in rightPowerList"
                :key="index">
                <el-tree
                  :data="[item]"
                  node-key="id"
                  :ref="'treex' + index"
                  show-checkbox
                  :default-expanded-keys="[0]"
                  empty-text=""
                  :default-checked-keys="systemArray"
                  :props="defaultProps"
                  :check-strictly="false"
                  @check-change="addSystemDepart"
                >
                </el-tree>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <base-dialog
      :dialogVisible.sync="dialogVisible"
      :title="titlex"
      @successEv="submitForm"
      @cancelEv="resetForm"
      :succlosedialog="false"
    >
      <el-form
        :model="numberValidateForm"
        ref="numberValidateForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="角色名称："
          prop="roleName"
          label-width="100px"
          :rules="[{
          required:true,
          message:'请输入角色名称',
          trigger: 'blur'
        }]">
          <el-input
            type="age"
            v-model="numberValidateForm.roleName"
            autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </base-dialog>
  </div>
</template>
<script>
  import baseDialog from '@/components/module/baseDialog'
  import {
    getRoleListAll,
    addresour,
    getInfoCheckstatus,
    getRoleInfodetail,
    addroleInfo,
    deletRoleInfo,
    getRoleDetail

  } from '@/api/system/rightsManagement.js'
  import { isEmpty } from 'loadsh'
  import { treeFind } from '@/util/tree'
  import {
    addRolePower,
    getPowerByRoleId,
    getRolePermission,
    loadchilddata,
    queryPostPowerByFatherIds
  } from '@/api/system/rightsManagement'
  import { isSuccess } from '@/util/tool'
  import { deepClone } from '@/util'

  export default {
    components: {
      baseDialog
    },
    data () {
      return {
        loding: true,
        forward: {
          id: '',
          pather: ''
        },
        isIndeterminate: false,
        selectLit: [],
        defaultProps: {
          label: 'powerName',
          children: 'powerChilds'
        },
        numberValidateForm: {
          roleName: ''
        },
        resource: [],
        checkItem: {},
        SelectCheck: [],
        listAll: [],
        checked: false,
        currindec: [],
        visible: false,
        currindex: '',
        Actionable: [],
        queryParams: {},
        currendItem: {},
        dialogVisible: false,
        roelNameList: [],
        onecheck: [],
        systemArray: [],
        titlex: '新增角色',
        rightPowerList: [],
        roleObj: ''
      }
    },
    created () {
    },
    watch: {
      pather: {
        deep: true,
        handler: function (newVal, oldVal) {
        }
      },
      checkItem: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (!newVal.checked) {
            this.resource = []
          }
        }
      },
      resource: {
        deep: true,
        handler: function (newVal) {
          return newVal
        }
      },
      currindec (newVal, oldVla) {
        if (newVal.length === 0) {
        }
      }
    },
    mounted () {
      this.getInit()
    },

    methods: {
      seeNodeClick (data, node, el) {
        this.getRightPowers(node.checkedKeys)
      },
      getRightPowers (data) {
        queryPostPowerByFatherIds(data).then(res => {
          if (isSuccess(res)) {
            this.rightPowerList = res.data.obj
            this.loding = false
          }
        })
      },
      addSystemDepart (data, checked, ex) {
        // const id = data.id
        // const {systemArray} = this
        // if(id === 0) return
        // if(systemArray.includes(id) && !checked){
        //   this.systemArray = systemArray.filter(ids => ids !== id)
        // }else{
        //   this.systemArray.push(id)
        // }
      },
      loadChildDataex (e, node, data) {
        /**
         * 获取所有iconfont图标
         * */
        const iconfontlist = document.getElementsByClassName('iconfont icon-youjiantou-01')
        const curEl = e.target.parentNode.lastChild
        const curicont = curEl && curEl.className
        for (var i = 0; i < iconfontlist.length; i++) {
          iconfontlist[i].className = 'iconfont icon-youjiantou-01'
        }
        if (curicont && curicont === 'iconfont icon-youjiantou-01') {
          curEl.className = 'iconfont icon-youjiantou-01 rotate'
          loadchilddata({
            id: data.id
          }).then(res => {
            if (isSuccess(res)) {
              const a = [{
                powerName: '全选',
                id: 0,
                powerChilds: res.data.obj
              }]
              this.resource = a
            }
          })
        } else if (curicont && curicont.includes('iconfont icon-youjiantou-01 rotate')) {
          this.resource = []
        }
      },
      loadChildData (e, node, data) {

        /**
         * 获取所有iconfont图标
         * */
        const iconfontlist = document.getElementsByClassName('iconfont icon-youjiantou-01')
        const curEl = e.target.children[1]
        const curicont = curEl && curEl.className
        for (var i = 0; i < iconfontlist.length; i++) {
          iconfontlist[i].className = 'iconfont icon-youjiantou-01'
        }
        if (!data.postPower) {
          this.resource = []
          return
        }

        if (curicont && curicont === 'iconfont icon-youjiantou-01') {
          curEl.className = 'iconfont icon-youjiantou-01 rotate'
          loadchilddata({
            id: data.id
          }).then(res => {
            if (isSuccess(res)) {
              const a = [{
                powerName: '全选',
                id: 0,
                powerChilds: res.data.obj
              }]
              this.resource = a
            }
          })
        } else if (curicont && curicont.includes('iconfont icon-youjiantou-01 rotate')) {
          this.resource = []
        }

      },
      tosave () {
        const { currendItem, rightPowerList } = this
        const leftr = this.$refs.tree.getCheckedKeys()
        const leftrex = this.$refs.tree.getCheckedNodes()
        const rightPower = []
        leftrex.forEach(item => {
          // 添加查看权限二级菜单ID
          if (item.powerFather !== 0 && !leftr.includes(item.powerFather)) {
            leftr.push(item.powerFather)
          }
          // 当子级选中时，需要带上一级的ID
          if (item.fastId && !leftr.includes(item.fastId)) {
            leftr.push(item.fastId)
          }
        })
        // 保存操作权限
        rightPowerList.forEach((itemex, index) => {
          rightPower.push(...(this.$refs['treex' + index][0].getCheckedKeys()))
        })
        addRolePower(currendItem.id, leftr.concat(rightPower)).then(res => {
          if (isSuccess(res)) {
            this.$message.success('修改成功！')
            // 刷缓存
            this.$axios.get('/api/auth/rebuildUserPowerAndMenu')
            return
          }
          this.$message.error(res.data.msg)
        })
      },
      getcheckitem (tree, c) {
        tree.forEach(res => {
          this.$set(res, 'checked', c)
          this.currindec.push(res)
          if (res.children) {
            this.getcheckitem(res.children, c)
          }
        })
      },
      // 取消父级选中
      cancelCurParentSelect (data, row) {
        data.forEach(item => {
          if (item.id === row.powerFather) {
            item.checked = false
          }
          if (item.children && item.children.length) {
            this.cancelCurParentSelect(item.children, row)
          }
        })
      },
      selectItem (clieck, e) {
        this.checkItem = clieck
        if (!clieck.checked) {
          this.cancelCurParentSelect(this.listAll, clieck)
        }
        this.currindec = []
        this.$set(clieck, 'checked', clieck.checked)
        this.getcheckitem([clieck], clieck.checked)

        if (this.currindec.length > 0) {
          this.resource = []
          this.resource.unshift({
            id: 999999999,
            powerName: '全选',
            checked: false
          })
          this.currindec.forEach(res => {
            if (res.checked) {
              getInfoCheckstatus(this.forward.id, this.forward.pather).then(
                res => {
                  let response = JSON.parse(JSON.stringify(res.data.obj))
                  response = response || []
                  this.resource.push(...response)
                }
              )
            }
          })
        } else {
          this.resource = []
        }
      },
      resetForm () {
        this.numberValidateForm.roleName = ''
      },
      submitForm () {
        this.$refs.numberValidateForm.validate(vail => {
          if (vail) {
            const { roleObj } = this
            addroleInfo({
              flag: true,
              id: roleObj.id || 0,
              orgId: 0,
              roleClass: '',
              roleCode: '',
              roleName: this.numberValidateForm.roleName
            }).then(res => {
              if (isSuccess(res)) {
                this.dialogVisible = false
              }
              this.$message({
                message: res.data.msg,
                type: res.data.code === 200 ? 'success' : 'error'
              })
              this.getInit()
            })
          }
        })
      },
      getRoelALL () {
        // 这是所有的的权限信息getRoleDetail
        getRolePermission().then(res => {
          if (isSuccess(res)) {
            this.listAll = res.data.obj
          }
        })
      },
      async getInit () {
        await getRoleListAll().then(res => {
          if (res.data.code === 200) {
            this.roelNameList = res.data.obj.records
            this.currendItem = this.roelNameList[0]
          }
        })
        await getRolePermission().then(res => {
          if (isSuccess(res)) {
            this.listAll = res.data.obj
          }
        })
        this.toclick(0, this.roelNameList[0])
        this.getRoelALL()
      },

      append (data) {
        // const newChild = { id: id++, label: 'testtest', children: [] }
        // if (!data.children) {
        //   this.$set(data, 'children', [])
        // }
        // data.children.push(newChild)true
      },

      remove (node, data) {
        const parent = node.parent
        const children = parent.data.children || parent.data
        const index = children.findIndex(d => d.id === data.id)
        children.splice(index, 1)
      },
      toaddRoleInfo (v) {
        if (v) {
          this.numberValidateForm.roleName = v.roleName
          this.titlex = '编辑角色'
        } else {
          this.numberValidateForm.roleName = ''
          this.titlex = '新增角色'
        }
        this.roleObj = v
        this.dialogVisible = true
      },
      toshow (v) {
        v.isshow = !v.isshow
        if (v.isshow) {
          deletRoleInfo(v.id).then(res => {
            this.$message({
              message: res.data.msg,
              type: res.data.code === 200 ? 'success' : 'error'
            })
            this.getInit()
          })
        }
      },
      getTreeFind (tree, pid) {
        for (let index = 0; index < tree.length; index++) {
          const element = tree[index]
          if (element.id === pid) {
            this.pather = element
          } else {
            if (element.children && element.children.length) {
              this.getTreeFind(element.children, pid)
            }
          }
        }
      },
      async toclick (i, v) {
        this.loding = true
        this.rightPowerList = []
        const iconfontlist = document.getElementsByClassName('iconfont icon-youjiantou-01')
        for (let i = 0; i < iconfontlist.length; i++) {
          iconfontlist[i].className = 'iconfont icon-youjiantou-01'
        }
        this.currindex = i
        this.forward.id = v.id
        this.currendItem = v
        // 获取id以后去查询做便利操作判断她powerFather
        // 获取父级和选中的子集
        let parentId = []
        const { listAll } = this
        this.listAll = deepClone(listAll)
        this.resource = []
        this.selectLit = []
        this.systemArray = []
        getPowerByRoleId({
          roId: v.id
        }).then(res => {
          if (isSuccess(res)) {
            const { getPower, postPower } = res.data.obj
            this.selectLit = deepClone(getPower || [])
            this.systemArray = deepClone(postPower || [])
            if (!isEmpty(this.selectLit)) {
              this.getRightPowers(this.selectLit)
            } else {
              this.loding = false
            }
          }
        })
      },
      async List () {
        const { data: res } = await this.$axios.get(
          '/api/systemPower/queryPowerAll'
        )
      }
    }
  }
</script>
<style
  lang="less"
  scoped>
  .right_add {
    width: 30%;
  }

  .left-logo {
    width: 8%;
    margin-right: -17px;
    margin-left: -13px;
  }

  /deep/ .checked_not_success {
    color: #276cff !important;
  }

  /deep/ .checked_not_error {
    color: #4e555b !important;
  }

  .roleNamw {
    width: 100%;
    display: flex;

    .leftcontent {
      width: 100%;
      display: flex;
    }
  }

  /deep/ .el-tree-node__content {
    height: 34px !important;
  }

  .itemsource:hover {
    background-color: rgba(39, 108, 255, 0.04);
  }

  .itemsource_box {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100% - 40px);
  }

  .itemsource {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    justify-content: space-between;
  }

  .content_role {
    width: 100%;
    overflow: hidden;
    // height: 100px;
    background-color: #f5f7fa;
    display: flex;

    .left {
      width: 284px;
      min-width: 284px;
      background-color: #ffffff;
      margin-right: 20px;
      border-radius: 4px;
      padding: 20px;
      box-sizing: border-box;
      height: calc(100vh - 220px);
      overflow: hidden;

      .delete_info {
        color: #d35e5e;

        &:hover {
          background: rgba(39, 108, 255, .04) !important;
        }
      }

      .rolellist {
        font-size: 14px;
        overflow-y: auto;
        overflow-x: hidden;
        height: calc(100% - 50px);

        ul {
          list-style: none;
          margin-top: 0;
          padding-left: 0px;

          li {
            display: flex;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;

            &:hover {
              background-color: rgba(39, 108, 255, 0.05);
            }

            .icong_span {
              display: flex;
              align-items: center;
              padding: 10px;
              justify-content: flex-end;

              position: relative;

              .right_info {
                position: absolute;
                width: 100px;
                height: 40px;
                background-color: #ffffff;
              }
            }
          }
        }
      }

      .activerole {
        justify-content: space-between;
        // opacity: 0.2;
        background-color: rgba(39, 108, 255, 0.1);

        .leftcontent {
          width: 100%;
          display: flex;
          color: #276cff;
          // justify-content: space-around;
        }

        // span {
        //   width: 33.3%;
        // }
        // opacity: 0.1;
        border-radius: 4px;
      }

      .roleName {
        display: flex;
        height: 30px;
        background-color: #f5f7fa;
        justify-content: space-around;
        align-items: center;

        .right_select_add {
          display: flex;
          align-items: center;

          img {
            margin-right: 5px;
          }
        }
      }
    }

    .right {
      width: calc(100% - 16% - 20px);
      background-color: #ffffff;
      box-sizing: border-box;
      border-radius: 4px;
      height: calc(100vh - 220px);

      .right_top {
        display: flex;
        justify-content: space-between;
        color: #4e555b;
        padding: 0px 20px;
        font-size: 15px;
        font-weight: 500;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ECEEF6;
      }

      .content_bottom {
        height: calc(100% - 65px);
        overflow: hidden;
        width: 100%;
        display: flex;
        .common() {
          width: 50%;
          border-radius: 0px;
        }

        .left {
          height: 100%;
          overflow: hidden;
          border-right: 1px solid #eceef6;
          .common();

          .left_tree {
            height: calc(100% - 40px);
            overflow-y: auto;
          }
        }

        .right {
          margin-right: 30px;
          height: 100%;
          overflow: hidden;
          padding: 20px 10px;
          .common();
        }

        .top {
          font-size: 18px;
          margin-bottom: 15px;
          font-size: 18px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #4e555b;
        }
      }
    }
  }

  .custom-tree-node {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  /deep/ .el-checkbox:last-of-type {
    order: 9;
  }

  /deep/ .el-tree-node__label {
    flex: 1;
  }

  /deep/ .left_tree > .el-tree > .el-tree-node > .el-tree-node__content .slot_title {
    font-weight: bold;
    font-size: 14px;
    color: #4E555B;
  }

  /deep/ .left_tree > .el-tree > .el-tree-node > .el-tree-node__content .el-tree-node__expand-icon {
    color: #4E555B;
  }

  /deep/ .el-tree-node__expand-icon.is-leaf {
    color: transparent !important;
  }

  /deep/ .itemsource_box .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  /deep/ .itemsource_box .el-tree-node__label {
    margin-left: 8px;
  }

  /deep/ .el-tree-node[aria-checked="true"] {
    color: #276CFF;
  }

  .rotate.iconfont.icon-youjiantou-01 {
    transform: rotate(90deg) translateY(-10px);
    transform-origin: 3px 3px;
  }

  .iconfont.icon-youjiantou-01 {
    display: inline-block;
  }
</style>
<style>
  .poperhover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 10px 0;
  }

  .delete_info:hover {
    background: rgba(39, 108, 255, .04) !important;
  }
</style>
